import type { FaireProductEntity } from "../../entity_types/product";

export const p_582dabhcpy: FaireProductEntity = {
  token: "p_582dabhcpy",
  type: "product",
  name: "Crystal Gold Wire Wrapped Necklaces - Assortment 12 Pcs",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/8d58f5d0fc5b97a96b38530c0b8e21dc7bebbd65cb4ee5f1738fe4693718588a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d952021f8fdc2cbb1b24862d04dc072cbdff28d261aaebe69ed6a5350c45600e.jpeg",
    "https://cdn.faire.com/fastly/ef1b7ec0dd0933a5b68507dd1186497699cb2cfef55cc2b58dc7129b38040df4.jpeg",
    "https://cdn.faire.com/fastly/e3b26fb3e30f95c4f0d1e8189b19723bcccd9e77e4c2f7e69a7bd079b40be7f3.jpeg",
    "https://cdn.faire.com/fastly/3ed808f3c1afd182e14adf60b377b981c2ee846c979c5ef314f492fe48d7a02b.jpeg",
    "https://cdn.faire.com/fastly/95c53824e25b3837c3c63975ed600b6c7c260ef2ac9d5d5c44b2615fe13bec3c.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Creating a necklace that combines both beauty and strength, this wire wrapped crystal point necklace is made in stainless steel with 20-inch chain. The final product is not just a beautiful piece of jewelry, but also a long lasting one that can withstand the harshness of daily wear.\n\nPackage content:\n1 case contains an assortment of 12 handmade necklaces. \n\n*100% Handmade\n*Made with positive vibes in mind",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:59.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
